module.exports = __webpack_public_path__ + "img/slim_cleanstation17.e8edaf38.jpg";